import React from "react";
import { Modal } from "react-bootstrap";
import './Loading.css';
import logo from './logo-white.png';
import { useSelector } from 'react-redux';

function Loading() {
    const loading = useSelector(state => state.loading.loading);

    return (
        <Modal show={loading} className="my-modal" centered>
            <img alt="logo" className="loading-image" src={logo} />
        </Modal>
    );
}
export default Loading;